import { render, staticRenderFns } from "./gift-card-input.vue?vue&type=template&id=2ea508ac"
import script from "./gift-card-input.vue?vue&type=script&lang=js"
export * from "./gift-card-input.vue?vue&type=script&lang=js"
import style0 from "./gift-card-input.vue?vue&type=style&index=0&id=2ea508ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports